import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const renewalPostDocUpload = async (data) => {
  api.post(API_URL + "renewal-postdoc", data);
};

export const getRenewalPostDoc = async (rp_id) => {
  return api
    .get(API_URL + `renewal-postdoc/${rp_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getRenewalPostDocMentor = async (mentor_id) => {
  return api
    .get(API_URL + `renewal-postdoc/mentor/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getRenewalPostDocAdmin = async () => {
  return api
    .get(API_URL + `renewal-postdoc/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const mentorConfirm = async (id, data) => {
  return api.put(API_URL + `renewal-postdoc/mentor/${id}`, data);
};

export const adminConfirm = async (id) => {
  return api.put(API_URL + `renewal-postdoc/admin/${id}`);
};
